export const authRoutes = {
  changePassword: "change-password",
  forgotPassword: "forgot-password",
};

export const investigatorRoutes = {
  investigationAnalysis: "investigation-analysis",
  logs: "logs",
  visualizationInterface: "visualization-interface",
  taskStatus: "task-status",
  filesPreview: "files-preview",
  oldLogs: "old-logs",
  dataValidation: "data-validation",
  validateData: "validate-data",
};
